import React from "react";
import {
  Avatar,
  Box,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/core";
import { FiMenu } from "react-icons/fi";
import { IconContext } from "react-icons";
import { logout } from "../../api/auth.service";
import useAuth from "../../context/AuthContext";
import { useHistory } from "react-router";
import { useWindowDimensions } from "../../lib/utils/hooks";
import { Link } from "react-router-dom";
import logoImg from "../../assets/images/green-logo.png";
import { getUserProfile } from "../../api/user.service";

export const Header = ({ icon, toggle }) => {
  const history = useHistory();
  const toast = useToast();
  const initialProfile = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    gender: "",
    profile: {},
  };
  const [profile, setUserProfile] = React.useState(initialProfile);

  const { width } = useWindowDimensions();

  const isMobile = width <= 600;

  const {
    dispatch,
    state: { user },
  } = useAuth();
  const logoutUser = () => {
    dispatch({ type: "LOGOUT" });
    logout();
    toast({
      title: "User Logout",
      description: "You have been logged out",
      status: "success",
      position: "top-right",
      isClosable: true,
    });
    history.push("/");
  };

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await getUserProfile();
        data && setUserProfile(data);
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <Flex
      justifyContent='space-between'
      align='center'
      shadow='sm'
      h={["80px", "55px"]}
      padding={["20px 30px", "10px 30px"]}
      bg='white'
      shadow='sm'
      borderBottom='2px solid #eee'
      py='2'
      position='fixed'
      w={["100vw", "100%"]}
      zIndex='320'
      top='0'
      left='0'
    >
      <Box my='6' d='flex' justifyContent='start' px='6' d={["none", "flex"]}>
        {/* <Logo white /> */}
        <Flex align='center' justify='center'>
          <Link to='/'>
            <Box w={["80px", "100px"]} ml={["0", "6"]}>
              <Image src={logoImg} objectFit='contain' />
            </Box>
          </Link>
        </Flex>
      </Box>
      <Stack isInline spacing='4' align='center'>
        {/* <IconContext.Provider value={{ size: "24px", color: "gray" }}>
          <Box as={icon} d={["none", "flex"]}></Box>
        </IconContext.Provider> */}
        <IconContext.Provider value={{ size: "24px", color: "gray" }}>
          <Box as={FiMenu} d={["flex", "none"]} onClick={toggle}></Box>
        </IconContext.Provider>
      </Stack>
      <Box d='flex' align='center'>
        <Box>
          {user.gender === null ? (
            <Avatar src='https://bit.ly/broken-link' bg='green.400' size='sm' />
          ) : user.gender === "male" ? (
            <Image
              w='40px'
              h='40px'
              objectFit='cover'
              src={profile?.photo_url}
              alt='User'
              rounded='full'
              fallbackSrc='https://img.icons8.com/color/92/000000/user-male-circle--v1.png'
            />
          ) : (
            <Image
              w='40px'
              h='40px'
              objectFit='cover'
              src={profile?.photo_url}
              fallbackSrc='https://img.icons8.com/color/92/000000/circled-user-female-skin-type-6--v1.png'
              alt='User'
              rounded='full'
            />
          )}
        </Box>
        <Menu>
          <MenuButton
            as={Text}
            variantColor='pink'
            alignSelf='center'
            mx={["2", "4"]}
            fontWeight='700'
            rightIcon='chevron-down'
          >
            {isMobile
              ? `${user.first_name}`
              : `${user.first_name} ${user.last_name}`}
          </MenuButton>
          <MenuList>
            <MenuGroup title='Profile'>
              <Link to='/dashboard/me'>
                <MenuItem>My Account</MenuItem>
              </Link>

              <MenuItem onClick={logoutUser}>Log out </MenuItem>
            </MenuGroup>
          </MenuList>
        </Menu>
      </Box>
    </Flex>
  );
};
